import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import "./QuestChart.css";
const CustomLegendOld = ({ data, activeKeys, toggleKey, type }) => {
  return (
    <div className="custom-legend">
      {data?.map((entry, index) => (
        <div
          key={index}
          className="legend-item"
          onClick={() => toggleKey(entry?.name)}
          style={{
            cursor: "pointer",
            opacity: activeKeys?.includes(entry?.name) ? 1 : 0.5,
          }}
        >
          <div
            className="legend-color-box"
            style={{ backgroundColor: entry?.color }}
          ></div>
              <span className="legend-text">{entry?.name}</span>
        </div>
      ))}
    </div>
  );
};
const CustomLegend = ({ data, activeKeys, toggleKey, type }) => {
  return (
    <div className="custom-legend-grid">
      {data?.map((entry, index) => (
        <div
          key={index}
          className="legend-item"
          onClick={() => toggleKey(entry?.name)}
          style={{
            cursor: "pointer",
            opacity: activeKeys?.includes(entry?.name) ? 1 : 0.5,
            display: "flex",
            alignItems: "center",
          }}
        >
          <div
            style={{
              backgroundColor: entry?.color,
              width: 12,
              height: 12,
              marginRight: 8,
            }}
          ></div>
          <span>
            {entry?.name} ({entry?.value}%)
          </span>
        </div>
      ))}
    </div>
  );
};

const CustomTooltip = ({ active, payload, type }) => {
  if (active && payload && payload.length) {
    const { name, value } = payload[0];
    return (
      <div
        style={{ background: "#fff", padding: "8px", border: "1px solid #ccc" }}
      >
        <strong>{name}</strong>: {value} {type === "percent" ? "%" : ""}
      </div>
    );
  }
  return null;
};
const QuestCompletionStatusPieChart = ({ data, type }) => {
  const [activeKeys, setActiveKeys] = useState([]);

  useEffect(() => {
    if (data && data.length) {
      setActiveKeys(data.map((d) => d.name));
    }
  }, [data]);

  const toggleKey = (key) => {
    setActiveKeys((prev) =>
      prev?.includes(key)
        ? prev.filter((k) => k !== key)
        : [...(prev ?? []), key]
    );
  };

  const filteredData = data?.filter((d) => activeKeys?.includes(d?.name)) ?? [];
  const allZero = filteredData.every((d) => d.value === 0);

  const pieData = allZero
    ? [{ name: "Incomplete", value: 100, color: "#1C8AB8" }] // Replace #E0E0E0 with any neutral color
    : filteredData;

  return (
    <>
      <div className="chart-legend-wrapper">
        <div className="pie-chart-container">
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={pieData}
                cx="50%"
                cy="50%"
                innerRadius={0}
                outerRadius={100}
                dataKey="value"
                stroke="none" // optional to ensure no border li
              >
                {pieData.map((entry, index) => (
                  <Cell key={index} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip content={<CustomTooltip type={type} />} />
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div className="legend-container">
          {type === "percent" ? (
            <CustomLegend
              data={data}
              activeKeys={activeKeys}
              toggleKey={toggleKey}
            />
          ) : (
            <CustomLegendOld
              data={data}
              activeKeys={activeKeys}
              toggleKey={toggleKey}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default QuestCompletionStatusPieChart;
